/* @flow */

import { combineReducers } from 'redux';
import reduceReducers from 'reduce-reducers';
import advancedSearchReducer from './advancedSearch';
import dataReducer from './data';
import dealerReducer from './dealer';
import filtersReducer from 'CoreStore/filters';
import settingsReducer from './settings';
import geolocationReducer from 'CoreStore/geolocation';
import searchReducer from './search';
import viewModeReducer from './viewMode';
import WidgetFields from '../constants/WidgetFields';

export default reduceReducers(
  combineReducers({
    advancedSearch: advancedSearchReducer,
    dealer: dealerReducer,
    filters: filtersReducer,
    geolocation: geolocationReducer,
    search: searchReducer,
    settings: settingsReducer,
    viewMode: viewModeReducer,
    configuration: state => state || {},
    translations: state => state || [],
    widgetFields: state => state || WidgetFields
  }),
  dataReducer
);
